var map = {
	"./icon-21.png": "89e8",
	"./icon-35.png": "e30c",
	"./icon-37.png": "3061",
	"./icon-38.png": "61ba",
	"./icon-add.png": "8467",
	"./icon-bind.png": "0073",
	"./icon-catch.png": "4813",
	"./icon-chorus.png": "db26",
	"./icon-comment.png": "3dc5",
	"./icon-danmu.png": "7abc",
	"./icon-done.png": "66d6",
	"./icon-double-last.png": "03d3",
	"./icon-double.png": "a9a9",
	"./icon-ecom.png": "268f",
	"./icon-exploring.png": "60b5",
	"./icon-focus.png": "25e1",
	"./icon-four.png": "07f9",
	"./icon-gift.png": "f2d3",
	"./icon-invite.png": "db20",
	"./icon-last.png": "6da2",
	"./icon-mgmovie.png": "aa91",
	"./icon-new.png": "1541",
	"./icon-news.png": "72fd",
	"./icon-share.png": "3d4a",
	"./icon-signed.png": "4a7a",
	"./icon-singer.png": "3eb9",
	"./icon-video.png": "a19c",
	"./icon-view.png": "1b94",
	"./icon-vip.png": "3661",
	"./icon-watch.png": "a4f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c725";